import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Plus } from "lucide-react";

export const FaqSection = () => {
  const faqs = [
    {
      question: "¿Tengo que saber de tecnología?",
      answer:
        "No. Lo armamos nosotros de punta a punta. Vos vas a completar dos cosas: cuánto salió el presupuesto y si lo ganaste.",
    },
    {
      question: "¿Cuánto tarda?",
      answer: "Una semana desde que nos pasás los datos.",
    },
    {
      question: "¿Sirve para mi rubro?",
      answer:
        "Si tu negocio es pasar presupuestos o precios y esperar respuesta, sí. Aberturas, piletas, climatización, reformas, plomería, electricidad, paisajismo, solar, cerramientos y talleres mecánicos ya lo usan. También distribuidoras, importadoras, mayoristas y corralones.",
    },
    {
      question: "Ya tengo web, ¿sirve igual?",
      answer:
        "Te hacemos una nueva, sin costo extra. Si la tuya tiene una sola página, Google no entiende qué servicios ofrecés y no te muestra cuando te buscan.",
    },
    {
      question: "¿La web queda a mi nombre?",
      answer:
        "El sitio lo pagás una sola vez y es tuyo. Si además contratás el sistema de reactivación, el hosting y el mantenimiento van incluidos ahí — si en algún momento cancelás eso, el sitio deja de estar online hasta que lo alojes en otro lado o vuelvas a contratar el mantenimiento.",
    },
    {
      question: "¿Hay contrato?",
      answer: "No. Los contratos se usan para asustarte y que no canceles.",
    },
    {
      question: "¿Y si no funciona?",
      answer:
        "Sobre los servicios recurrentes, 30 días para pedir la devolución del mes, sin preguntas. El pago del sitio web es por trabajo entregado, no entra en la garantía.",
    },
    {
      question: "¿Cuánto cuesta esto?",
      answer:
        "Depende de qué necesitás. El sitio es un pago único de entre USD 500 y 950, según cuántas páginas. Si además querés que trabajemos tu base de contactos — pedir reseñas, avisar cuando toca volver a contratarte, hacer seguimiento — eso es un servicio aparte, recurrente. Podés empezar solo con el sitio.",
    },
    {
      question: "¿Me manejan la publicidad?",
      answer:
        "En el plan no. Primero va la base: sitio, ficha de Google y reseñas. Sin eso, la publicidad es plata tirada — por eso las veces anteriores no te funcionó. Cuando la base está, la pauta la cotizamos aparte.",
    },
    {
      question: "¿Esto lo hace un robot o lo hace gente?",
      answer:
        "Lo arma y lo mantiene nuestro equipo. Adentro hay automatizaciones e inteligencia artificial haciendo el trabajo repetitivo — el seguimiento, las reseñas, los recordatorios. Pero del otro lado del WhatsApp de soporte hay una persona.",
    },
    {
      question: "¿Trabajan con distribuidoras y mayoristas?",
      answer:
        "Sí, y hace años. Es la otra mitad de nuestros clientes. Mirá /distribuidoras.",
    },
    {
      question: "¿Puedo comprar solo el sitio web?",
      answer:
        "Sí. Es un servicio aparte, con su propio precio. El sistema completo se arma cuando además querés que trabajemos tu base de contactos.",
    },
    {
      question: "¿El Bot IA cierra la venta por mí?",
      answer:
        "No. Atiende, califica y agenda. Cuando el contacto está listo, te lo deriva a vos o a tu vendedor. Cerrar la venta lo seguís haciendo una persona.",
    },
  ];

  return (
    <section className="bg-[#08080A] py-24 lg:py-[160px] relative">
      <div className="container mx-auto px-6 max-w-[800px]">
        <div className="mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[#71717A] font-mono text-[13px] tracking-[0.08em] uppercase mb-6">
              FAQ — DUDAS FRECUENTES
            </p>
            <h2 className="text-[32px] md:text-[44px] lg:text-[56px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05]">
              Preguntas frecuentes
            </h2>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="w-full"
          >
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-white/10 last:border-0"
              >
                <AccordionTrigger className="py-6 hover:no-underline group [&[data-state=open]>div>svg]:rotate-45">
                  <div className="flex w-full items-center justify-between text-left">
                    <span className="text-[#FAFAFA] text-[18px] md:text-[20px] font-medium tracking-[-0.01em] pr-8">
                      {faq.question}
                    </span>
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <Plus className="w-5 h-5 text-[#7C3AED] transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]" />
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[#A1A1AA] text-[16px] leading-[1.6] pr-12">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
